import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import {
  BuxiRedDomain,
  BuxiRedLogoUrl,
  LOGO,
  PublicisDomain,
  PublicisLogoUrl,
  TOOLS,
} from '@constants/global';
import { WARNING_SVG } from '@constants/svg';
import { BasicInfoApiService } from '@core/http/api/basic-info.service';
import { UploadDialogService } from '@core/services/upload-dialog.service';
import { BatchUploadCampaignBudgetComponent } from '@features/promotion/common/campaign/app-batch-upload-campaign-budget/app-batch-upload-campaign-budget';
import { BatchUploadCampaignNameComponent } from '@features/promotion/common/campaign/batch-upload-campaign-name/batch-upload-campaign-name.component';
import { BatchUploadCampaignComponent } from '@features/promotion/common/campaign/batch-upload-campaign/batch-upload-campaign.component';
import { BatchEditCreativeComponent } from '@features/promotion/common/creative/batch-edit-creative/batch-edit-creative.component';
import { BatchUploadCreativeComponent } from '@features/promotion/common/creative/batch-upload-creative/batch-upload-creative.component';
import { BatchUploadMonitorComponent } from '@features/promotion/common/creative/batch-upload-monitor/batch-upload-monitor.component';
import { BatchUploadKeywordBidComponent } from '@features/promotion/common/keyword/batch-upload-keyword-bid/batch-upload-keyword-bid.component';
import { BatchUploadKeywordComponent } from '@features/promotion/common/keyword/batch-upload-keyword/batch-upload-keyword.component';
import { BatchUploadUnitBidComponent } from '@features/promotion/common/unit/batch-upload-unit-bid/batch-upload-unit-bid.component';
import { BatchUploadUnitTargetComponent } from '@features/promotion/common/unit/batch-upload-unit-target/batch-upload-unit-target.component';
import { HeaderTools } from '@shared/metadata/global.data';
import { NzAvatarComponent } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzMenuDirective, NzMenuItemComponent } from 'ng-zorro-antd/menu';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { StatesService } from 'src/app/core/store/states.service';
@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.less'],
  imports: [
    RouterLink,
    NzMenuDirective,
    ɵNzTransitionPatchDirective,
    NzMenuItemComponent,
    NzIconDirective,
    NzAvatarComponent,
    NzPopoverModule,
    NzButtonModule,
    BatchUploadCreativeComponent,
    BatchUploadMonitorComponent,
    BatchUploadKeywordComponent,
    BatchEditCreativeComponent,
    BatchUploadCampaignComponent,
    BatchUploadCampaignBudgetComponent,
    BatchUploadCampaignNameComponent,
    BatchUploadUnitBidComponent,
    BatchUploadUnitTargetComponent,
    BatchUploadKeywordBidComponent,
  ],
})
export class MainHeaderComponent implements OnInit {
  private statesService = inject(StatesService);
  private basicInfoApi = inject(BasicInfoApiService);
  private router = inject(Router);
  private ds = inject(DomSanitizer);
  uploadDialogService = inject(UploadDialogService);

  userInfo: UserInfo = this.statesService.userInfo$.getValue();
  HeaderTools = HeaderTools;
  LOGO = this.ds.bypassSecurityTrustHtml(LOGO);
  TOOLS = this.ds.bypassSecurityTrustHtml(TOOLS);
  saasUserInfo: any = {};
  otherLogo: any = null;
  warningSvg = this.ds.bypassSecurityTrustHtml(WARNING_SVG);

  ngOnInit(): void {
    this.getOtherLogo();
    this.statesService.saasUserInfo$.subscribe((userInfo) => {
      this.saasUserInfo = userInfo;
    });
  }

  getOtherLogo() {
    if (location.hostname === PublicisDomain) {
      this.otherLogo = PublicisLogoUrl;
    }
    if (location.hostname.includes(BuxiRedDomain)) {
      this.otherLogo = BuxiRedLogoUrl;
    }
  }

  // 退出登录
  signOut() {
    window.location.href = this.basicInfoApi.signOut();
  }
  // 打开工具
  handleEnterTool(item: { url?: string; isDialog?: boolean; dialogType?: string }) {
    if (item.isDialog) {
      switch (item.dialogType) {
        case 'campaignUpload':
          this.uploadDialogService.openUploadCampaignDialog();
          break;
        case 'creativeUpload':
          this.uploadDialogService.openUploadCreativeDialog();
          break;
        case 'creativeEdit':
          this.uploadDialogService.openEditCreativeDialog();
          break;
        case 'monitor':
          this.uploadDialogService.openUploadMonitorDialog();
          break;
        case 'keyword':
          this.uploadDialogService.openUploadKeywordDialog();
          break;
        case 'campaignBudget':
          this.uploadDialogService.openUploadCampaignBudgetDialog();
          break;
        case 'campaignName':
          this.uploadDialogService.openUploadCampaignNameDialog();
          break;
        case 'unitBid':
          this.uploadDialogService.openUploadUnitBidDialog();
          break;
        case 'unitTarget':
          this.uploadDialogService.openUploadUnitTargetDialog();
          break;
        case 'keywordBid':
          this.uploadDialogService.openUploadKeywordBidDialog();
          break;
        default:
          this.navigateToUrl(item.url || '');
      }
      return;
    }

    this.navigateToUrl(item.url || '');
  }

  // 处理带查询参数的 URL 导航
  private navigateToUrl(url: string) {
    if (url.includes('?')) {
      const [path, queryString] = url.split('?');
      const queryParams = new URLSearchParams(queryString);
      const queryParamsObj: any = {};
      queryParams.forEach((value, key) => {
        queryParamsObj[key] = value;
      });
      this.router.navigate([path], { queryParams: queryParamsObj });
    } else {
      this.router.navigate([url]);
    }
  }
}
